import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { VendorService } from './../../../../services/vendor.service';
import { DataService } from './../../../../services/data.service';
import { ModalComponent } from '../../../../shared-components/modal/modal.component';
import { EmailService } from '../../../../services/email.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-purchase-order-view',
  templateUrl: './purchase-order-view.component.html',
  styleUrls: ['./purchase-order-view.component.scss']
})
export class PurchaseOrderViewComponent implements OnInit, OnDestroy {
  public ItmPerPage: any = [{ id: 1, name: '10', value: '10 per page' },
  { id: 2, name: '25', value: '25 per page' },
  { id: 3, name: '50', value: '50 per page' }];
  purchaseordersPg: number = 1;
  selectedPoPerPageVal = '10 per page';
  purchaseorders: any = [];
  purchaseordersFilter: string = '';
  poSortBy: any = 'Date';
  poSortOrder: string = 'asc';
  userInfo: any;
  public searchText: string = '';
  selectedPONumber: string;
  public alive: boolean = true;
  @ViewChild('templatePODetails') templatePODetails: ModalComponent;
  @ViewChild('templateRequestPO') templateRequestPO: ModalComponent;
  constructor(private datasvc: DataService, private vendorsvc: VendorService ,
    private _spinner: NgxSpinnerService,
    private emailSvc: EmailService) { }

  ngOnInit() {
        this.userInfo = this.datasvc.userDisplayInfo;
        this.geVendorPo();
  }

  geVendorPo() {
    this.vendorsvc.getVendorPurchaseOrders(this.searchText, this.userInfo.GPVID).takeWhile(() => this.alive).subscribe(
      po => {
        this.purchaseorders = po;
        console.log('Vendor data', this.purchaseorders);

      });
  }

  showPODetails(poNumber: string) {
    this.selectedPONumber = poNumber;
    this.templatePODetails.show();
  }

  showRequestPOModal() {
    this.templateRequestPO.show();
  }

  getPdfFile(poNumber: string) {
    // Open window first to prevent ad blocker coming into play
     const loWinExt = window.open();
    //this._spinner.show();
    
    this.emailSvc.ExportReportToPDF(poNumber,"","","")
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          console.log('report'+data);
          const byteCharacters = atob(data);
          const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = poNumber+'.pdf'; // File name for download
          link.target='_blank';
          link.click();
        //this._spinner.hide();
        if (loWinExt)
        {
          loWinExt.close();
        }

          // if (loWinExt) {
          //   loWinExt.location.href =  data;
          // } else {
          //   window.open(data, '_blank');
          // }
        },
        err => {
          this._spinner.hide();
          console.log(err);
        }
      );
  }
  ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-vendor/purchase-order-view/purchase-order-view.component.ts